import React from "react";

/******************************************************
 *
 * Composant générique de saisie
 *
 ******************************************************/
export default function FormInput({

    /* Apparence */

    label = "",

    icon = "",

    placeholder = "",

    /* Type */

    type = "text",

    /* Valeur */

    name,

    value = "",

    onChange,

    onBlur,

    /* Validation */

    error = "",

    required = false,

    maxLength,

    min,

    max,

    step,

    /* Etat */

    disabled = false,

    readOnly = false,

    autoFocus = false,

    autoComplete = "off",

    /* Bootstrap */

    col = "col-12",

    labelCol = 4,

    inputCol = 8,

    className = ""

}) {

    //--------------------------------------------------

    return (

        <div className={`${col} mb-3`}>

            <div className="row align-items-center">

                {/*========================================*/}
                {/* Label */}
                {/*========================================*/}

                <label
                    className={`col-md-${labelCol} col-form-label fw-semibold`}
                >

                    {

                        icon && (

                            <i className={`${icon} me-2 text-success`}></i>

                        )

                    }

                    {label}

                    {

                        required && (

                            <span className="text-danger ms-1">*</span>

                        )

                    }

                </label>

                {/*========================================*/}
                {/* Champ */}
                {/*========================================*/}

                <div className={`col-md-${inputCol}`}>

                    <input

                        className={

                            `form-control ${error ? "is-invalid" : ""} ${className}`

                        }

                        type={type}

                        name={name}

                        value={value ?? ""}

                        placeholder={placeholder}

                        onChange={onChange}

                        onBlur={onBlur}

                        autoFocus={autoFocus}

                        autoComplete={autoComplete}

                        disabled={disabled}

                        readOnly={readOnly}

                        required={required}

                        maxLength={maxLength}

                        min={min}

                        max={max}

                        step={step}

                    />

                    {

                        error && (

                            <div className="invalid-feedback">

                                {error}

                            </div>

                        )

                    }

                </div>

            </div>

        </div>

    );

}